export const SAVE_AUTH = 'SAVE_AUTH';
export const LOGOUT = 'LOGOUT';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
